<template>
  <div>
    <slot name="activator" :open="open">
      <oie-base-action
        v-tooltip.top="t('myUsersChangeUsernameTooltip')"
        theme="outlined"
        @click="open">
        {{ t('myUsersChangeUsernameTitle') }}
      </oie-base-action>
    </slot>
    <oie-portal-wrapper :name="name">
      <template #title>
        <h2>{{ t('myUsersChangeUsernameTitle') }}</h2>
      </template>
      <validation-observer ref="observer" tag="div">
        <oie-form-wrapper class="input-column__container" @submit="changeUsername">
          <div v-html="t('myUsersChangeUsernameInfoText')"></div>
          <oie-base-input v-model="currentUsername" :label-text="t('myUsersCurrentUsernameLabel')" :is-readonly="true"></oie-base-input>
          <validation-provider v-slot="{errors}" slim rules="required|email">
            <oie-base-input v-model="newUsername" :label-text="t('myUsersNewUsernameLabel')" :error-messages="errors"></oie-base-input>
          </validation-provider>
          <oie-base-action type="submit">
            {{ tStatic('genericSave') }}
          </oie-base-action>
        </oie-form-wrapper>
      </validation-observer>
    </oie-portal-wrapper>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import httpService from '@/core/http-service'
import _ from 'lodash'

export default {
  props: {
    user: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      newUsername: ''
    }
  },
  computed: {
    currentUsername() {
      return this.user && this.user.userId
    }
  },
  beforeMount() {
    this.name = this.$attrs.id || _.uniqueId('change-username')
  },
  methods: {
    ...mapActions('ui', ['setActiveSlideIn']),
    open() {
      this.setActiveSlideIn(this.name)
    },
    async changeUsername() {
      const isValid = await this.$refs.observer.validate()
      if(!isValid) return
      await httpService.post('auth/myusers/changeUsername', { username: this.user.userId, newUsername: this.newUsername }).then((response) => {
        this.setActiveSlideIn(null)
        this.publish('my-users-change-username')
        this.newUsername = ''
      }).catch(() => {
      })
    }
  }
}
</script>

<style>

</style>
